import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  return (
    <div className={styles.headerContainer}>
      <div onClick={() => navigate("/")}>Wedding Cuisine</div>

      <div>
        <a href="/">Home</a>
        <a href="/locations">Locations</a>
        <a href="/kontakt">Kontakt</a>
      </div>
    </div>
  );
}

export default Header;
